import { ContentContainer } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Banner, Link, Stack } from '@optimus-web/core';

export const SecurityRestriction = () => (
    <ContentContainer style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <Stack vertical alignment="center" spacing="200">
            <Stack alignment="center">
                <Banner
                    primaryText={lt('SecuritySecureLoginInfoMessage', {
                        a: (text) => (
                            <Link
                                href="https://help.mews.com/s/article/turn-on-two-factor-authentication"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {text}
                            </Link>
                        ),
                    })}
                    variant="info"
                />
            </Stack>
        </Stack>
    </ContentContainer>
);
